<script setup>
import MWPLoginForm from "@/components/mwp/MWPLoginForm.vue"
</script>

<template>
  <MWPLoginForm />
</template>